// extracted by mini-css-extract-plugin
module.exports = {"image--simple":"_0fce717cdb--image--simple--_uRU_","image--empty":"_0fce717cdb--image--empty--vrjoE"};